import { useState } from "react";
import Highlight from "react-highlight";
import "./App.css";
import Footer from "./Footer";
import Header from "./Header";
import generateReduxFiles from "./generateReduxFiles";
import isValidHttpUrl from "./isValidHttpUrl";
import makePlural from "./makePlural";
import makeSingular from "./makeSingular";
import reduxIcon from "./redux.svg";

function App() {
  const [hasError, setHasError] = useState(false);
  const [moduleName, setModuleName] = useState("");
  const [reduxTypes, setReduxTypes] = useState([]);
  const [reduxReducers, setReduxReducers] = useState("");
  const [reduxActions, setReduxActions] = useState("");

  function generateRedux(e) {
    e.preventDefault();
    if (e.target.module.value && e.target.features.value && e.target.apiUrls.value && isValidHttpUrl(e.target.apiUrls.value)) {
      hasError && setHasError(false);
      setModuleName(e.target.module.value);
      generateReduxFiles(
        {
          module: e.target.module.value?.toLowerCase(),
          features: e.target.features.value,
          apiUrls: e.target.apiUrls.value,
        },
        function (reduxOutput) {
          setReduxTypes(reduxOutput?.reduxTypes);
          setReduxReducers(reduxOutput?.reduxReducers);
          setReduxActions(reduxOutput?.reduxActions);
        }
      );
    } else {
      !hasError && setHasError(true);
    }
  }

  return (
    <div className="App">
      <Header />
      <main className="App-Main">
        {hasError && (
          <div className="alert alert-warning alert-dismissible">
            <button type="button" className="btn-close" onClick={() => hasError && setHasError(false)}></button>
            <strong>Warning!</strong> All the input fields are required, and providing valid data is mandatory.
          </div>
        )}
        <form onSubmit={generateRedux}>
          <div className="row">
            <div className="col">
              <div className="form-floating mb-3">
                <input
                  type="text"
                  className="form-control"
                  id="module"
                  placeholder="Enter module name"
                  name="module"
                  style={{ textTransform: "lowercase" }}
                />
                <label htmlFor="module">
                  Module name <span className="text-danger">*</span>
                </label>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <div className="form-floating mb-3 mt-3">
                <select id="features" className="form-select" name="features">
                  <option value="rw">Read, and write both</option>
                  <option value="r">Read only</option>
                  <option value="w">Write only</option>
                </select>
                <label htmlFor="features">
                  Features <span className="text-danger">*</span>
                </label>
              </div>
            </div>
            <div className="col">
              <div className="form-floating mb-3 mt-3">
                <input type="text" className="form-control" id="apiUrls" placeholder="Enter module name" name="apiUrls" />
                <label htmlFor="apiUrls">
                  {/* API URL (use comma for multiple in CRUD flow) */}
                  API URL
                  <span className="text-danger">*</span>
                </label>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col text-center">
              <div className="form-floating mb-3 mt-3">
                <button type="submit" className="btn btn-primary px-3 py-2" style={{ fontSize: "1.5em", fontWeight: 600 }}>
                  <img alt="Generate" src={reduxIcon} height="25" />
                  &nbsp;Generate
                </button>
              </div>
            </div>
          </div>
        </form>
        <hr />
        {moduleName && (
          <div className="App-Output">
            <h3 className="text-center">
              Redux <span style={{ fontWeight: 600 }}>Output</span>
            </h3>
            <br />

            <p className="mb-0 text-secondary">
              FILE:{" "}
              <i>
                src/redux/{makePlural(moduleName).toLowerCase()}/{makeSingular(moduleName).toLowerCase()}Types.js
              </i>
            </p>
            <Highlight className="rounded" language="javascript">
              {reduxTypes.join("\n")}
            </Highlight>
            <br />
            <p className="mb-0 text-secondary">
              FILE:{" "}
              <i>
                src/redux/{makePlural(moduleName).toLowerCase()}/{makeSingular(moduleName).toLowerCase()}Reducer.js
              </i>
            </p>
            <Highlight className="rounded" language="javascript">
              {reduxReducers}
            </Highlight>

            <br />
            <p className="mb-0 text-secondary">
              FILE:{" "}
              <i>
                src/redux/{makePlural(moduleName).toLowerCase()}/{makeSingular(moduleName).toLowerCase()}Actions.js
              </i>
            </p>
            <Highlight className="rounded" language="javascript">
              {reduxActions}
            </Highlight>
          </div>
        )}
      </main>
      <Footer />
    </div>
  );
}

export default App;
